import { SuperuserIntegrationsPage } from "@/features/superuser/integrations/superuser-integrations.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/superuser/integrations")({
  component: SuperuserIntegrationsPage,
});
